/* poster-editor.js
   Editeur des posters personnalises (dessin au trait / portrait aquarelle couleur).

   Independant de l'editeur des cartes : aucun identifiant, aucune variable
   globale et aucune propriete de panier en commun (pas d'image_id).

   L'apercu du style est calcule dans le navigateur (gratuit, instantane). Le
   rendu final est realise par l'atelier apres la commande, puis le serveur
   posters fabrique chaque format en 300 dpi. */

(function () {
  'use strict';

  var racine = document.getElementById('poster-editor');
  if (!racine) return;

  var SERVEUR = (racine.dataset.server || '').replace(/\/$/, '');
  var STYLE = racine.dataset.style === 'aquarelle' ? 'aquarelle' : 'minimaliste';
  var VARIANTE = racine.dataset.variant;
  var EXEMPLE = racine.dataset.exemple || '';
  var LANG = racine.dataset.lang === 'en' ? 'en' : 'fr';

  var TXT = {
    fr: {
      photoIci: 'Votre photo ici',
      formatPhoto: 'Merci de choisir une photo (JPG, PNG ou HEIC).',
      preparation: 'Préparation de l\'aperçu...',
      tropPetite: 'Cette photo est trop petite. Choisissez une photo d\'au moins 400 px.',
      illisible: 'Ce format de photo n\'est pas lisible par votre navigateur. Essayez une capture d\'écran ou un JPG.',
      changer: 'Changer de photo',
      sansPhoto: 'Ajoutez d\'abord la photo de votre chien.',
      sansNom: 'Indiquez le prénom de votre chien.',
      indispo: 'Service momentanément indisponible.',
      envoi: 'Envoi de votre photo...',
      panier: 'Ajout au panier...',
      erreur: 'Une erreur est survenue, merci de réessayer dans un instant.',
      pNom: 'Prénom du chien', pDates: 'Dates', pPhrase: 'Phrase', pStyle: 'Style',
      aquarelle: 'Portrait aquarelle couleur', minimaliste: 'Dessin au trait'
    },
    en: {
      photoIci: 'Your photo here',
      formatPhoto: 'Please choose a photo (JPG, PNG or HEIC).',
      preparation: 'Preparing the preview...',
      tropPetite: 'This photo is too small. Please choose a photo of at least 400 px.',
      illisible: 'Your browser cannot read this photo format. Try a screenshot or a JPG.',
      changer: 'Change photo',
      sansPhoto: 'Please add your dog\'s photo first.',
      sansNom: 'Please enter your dog\'s name.',
      indispo: 'Service temporarily unavailable.',
      envoi: 'Uploading your photo...',
      panier: 'Adding to cart...',
      erreur: 'Something went wrong, please try again in a moment.',
      pNom: 'Dog\'s name', pDates: 'Dates', pPhrase: 'Words', pStyle: 'Style',
      aquarelle: 'Colour watercolour portrait', minimaliste: 'Line drawing'
    }
  }[LANG];

  var $ = function (id) { return document.getElementById(id); };
  var toile = $('pe-canvas');
  var ctx = toile.getContext('2d');

  /* meme mise en page que rendu.py (fractions de la largeur) */
  var W = 900, H = Math.round(900 * 297 / 210);
  toile.width = W; toile.height = H;

  var CONF = {
    minimaliste: {
      papier: [252, 249, 243], encre: [70, 55, 48],
      nomPolice: "'Great Vibes', cursive", nomTaille: 0.125,
      majuscules: false, espacement: 0, nomCouleur: '#4a3a32', filet: true
    },
    aquarelle: {
      papier: [252, 249, 243], encre: null,
      nomPolice: "'Great Vibes', cursive", nomTaille: 0.125,
      majuscules: false, espacement: 0, nomCouleur: '#4a3a32', filet: true
    }
  }[STYLE];

  var photoOriginale = null;   // HTMLImageElement
  var portraitStylise = null;  // image ou canvas affiche dans le poster

  /* portrait d'exemple (vrai rendu atelier) : c'est lui qui est montre dans
     l'apercu ; sans exemple, on retombe sur le filtre applique a la photo */
  var exemple = null;
  if (EXEMPLE) {
    exemple = new Image();
    exemple.onload = function () { portraitStylise = exemple; dessiner(); };
    exemple.src = EXEMPLE;
  }

  /* reveille le serveur (hebergement gratuit en veille) pendant que la
     cliente personnalise son poster */
  if (SERVEUR) fetch(SERVEUR + '/health', { mode: 'cors' }).catch(function () {});

  /* ------------------------------------------------------------------
     filtres d'apercu
     ------------------------------------------------------------------ */
  function flou(src, w, h, r) {
    // flou boite separable, 3 passes ~ gaussien
    var a = new Float32Array(src), b = new Float32Array(src.length);
    for (var p = 0; p < 3; p++) {
      for (var y = 0; y < h; y++) {
        var s = 0, o = y * w;
        for (var x = -r; x <= r; x++) s += a[o + Math.min(w - 1, Math.max(0, x))];
        for (x = 0; x < w; x++) {
          b[o + x] = s / (2 * r + 1);
          s += a[o + Math.min(w - 1, x + r + 1)] - a[o + Math.max(0, x - r)];
        }
      }
      for (x = 0; x < w; x++) {
        s = 0;
        for (y = -r; y <= r; y++) s += b[Math.min(h - 1, Math.max(0, y)) * w + x];
        for (y = 0; y < h; y++) {
          a[y * w + x] = s / (2 * r + 1);
          s += b[Math.min(h - 1, y + r + 1) * w + x] - b[Math.max(0, y - r) * w + x];
        }
      }
    }
    return a;
  }

  /* 1 au centre, 0 sur les bords : le decor de la photo s'efface dans le papier */
  function fonduOvale(x, y, w, h) {
    var xx = (x - w / 2) / (w * 0.46), yy = (y - h / 2) / (h * 0.47);
    return Math.max(0, Math.min(1, (1 - Math.sqrt(xx * xx + yy * yy)) / 0.28));
  }

  function styliser(img) {
    var max = 760;
    var k = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
    var w = Math.round(img.naturalWidth * k), h = Math.round(img.naturalHeight * k);
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    var x = c.getContext('2d');
    x.drawImage(img, 0, 0, w, h);
    var d = x.getImageData(0, 0, w, h), px = d.data, n = w * h, i;

    if (STYLE === 'minimaliste') {
      // croquis au trait : densite de l'encre = divergence entre gris et gris floute
      var gris = new Float32Array(n);
      for (i = 0; i < n; i++) gris[i] = 0.299 * px[i * 4] + 0.587 * px[i * 4 + 1] + 0.114 * px[i * 4 + 2];
      var f = flou(gris, w, h, 5);
      for (i = 0; i < n; i++) {
        var v = Math.min(255, gris[i] * 255 / Math.max(1, f[i]));
        v = v > 235 ? 255 : Math.max(0, (v - 150) * 255 / 85);
        v = 255 - (255 - v) * fonduOvale(i % w, Math.floor(i / w), w, h);
        px[i * 4] = px[i * 4 + 1] = px[i * 4 + 2] = v;
      }
    } else {
      // portrait aquarelle : sans exemple, la photo elle-meme, fondue dans le papier
      for (i = 0; i < n; i++) {
        var fondu = fonduOvale(i % w, Math.floor(i / w), w, h);
        px[i * 4] = 255 - (255 - px[i * 4]) * fondu;
        px[i * 4 + 1] = 255 - (255 - px[i * 4 + 1]) * fondu;
        px[i * 4 + 2] = 255 - (255 - px[i * 4 + 2]) * fondu;
      }
    }
    x.putImageData(d, 0, 0);
    return c;
  }

  /* ------------------------------------------------------------------
     composition de l'apercu
     ------------------------------------------------------------------ */
  function mesurer(texte, esp) {
    var l = 0;
    for (var i = 0; i < texte.length; i++) l += ctx.measureText(texte[i]).width;
    return l + esp * Math.max(0, texte.length - 1);
  }

  function ecrire(texte, cx, y, esp) {
    if (!esp) { ctx.textAlign = 'center'; ctx.fillText(texte, cx, y); return; }
    ctx.textAlign = 'left';
    var x = cx - mesurer(texte, esp) / 2;
    for (var i = 0; i < texte.length; i++) {
      ctx.fillText(texte[i], x, y);
      x += ctx.measureText(texte[i]).width + esp;
    }
  }

  function ajuster(texte, police, taille, esp, max) {
    while (taille > 8) {
      ctx.font = taille + 'px ' + police;
      if (mesurer(texte, esp * taille) <= max) break;
      taille = Math.floor(taille * 0.94);
    }
    return taille;
  }

  function couper(texte, max) {
    var mots = texte.split(/\s+/), lignes = [], cour = '';
    mots.forEach(function (m) {
      var essai = (cour + ' ' + m).trim();
      if (ctx.measureText(essai).width <= max || !cour) cour = essai;
      else { lignes.push(cour); cour = m; }
    });
    if (cour) lignes.push(cour);
    return lignes.slice(0, 2);
  }

  function dessiner() {
    var nom = $('pe-name').value.trim();
    var dates = $('pe-dates').value.trim();
    var phrase = $('pe-phrase').value.trim();
    var p = CONF.papier;

    ctx.fillStyle = 'rgb(' + p.join(',') + ')';
    ctx.fillRect(0, 0, W, H);
    ctx.textBaseline = 'top';

    /* bloc texte */
    var el = [], h = 0, max = 0.8 * W, t;
    if (nom) {
      var txt = CONF.majuscules ? nom.toUpperCase() : nom;
      t = ajuster(txt, CONF.nomPolice, Math.round(CONF.nomTaille * W), CONF.espacement, max);
      el.push({ txt: txt, font: t + 'px ' + CONF.nomPolice, col: CONF.nomCouleur, esp: CONF.espacement * t, y: h });
      h += t * 1.3;
    }
    if (nom && (dates || phrase)) h += 0.012 * W;
    if (dates) {
      t = ajuster(dates, "'Playfair Display', Georgia, serif", Math.round(0.032 * W), 0.30, max);
      el.push({ txt: dates, font: t + "px 'Playfair Display', Georgia, serif", col: '#60524a', esp: 0.30 * t, y: h });
      h += t * 1.35;
    }
    /* petit trait sous les dates ; absent quand seul le prenom est demande */
    if (CONF.filet && (dates || phrase)) { h += 0.024 * W; el.push({ filet: true, y: h }); h += 0.004 * W; }
    if (phrase) {
      h += 0.034 * W;
      t = Math.round(0.031 * W);
      ctx.font = "italic " + t + "px 'Playfair Display', Georgia, serif";
      couper(phrase, max * 0.85).forEach(function (l) {
        el.push({ txt: l, font: "italic " + t + "px 'Playfair Display', Georgia, serif", col: '#60524a', esp: 0.10 * t, y: h });
        h += t * 1.6;
      });
    }

    /* memes proportions que rendu.py (modele Nala) */
    var mh = 0.16 * W, mb = 0.21 * W, ecart = h ? 0.05 * W : 0;
    var zh = H - mh - mb - h - ecart, zw = 0.60 * W;

    /* portrait */
    if (portraitStylise) {
      var s = Math.min(zw / portraitStylise.width, zh / portraitStylise.height);
      var nw = portraitStylise.width * s, nh = portraitStylise.height * s;
      ctx.globalCompositeOperation = 'multiply';
      ctx.drawImage(portraitStylise, (W - nw) / 2, mh + (zh - nh) / 2, nw, nh);
      ctx.globalCompositeOperation = 'source-over';
    } else {
      ctx.strokeStyle = '#d9cfc6';
      ctx.setLineDash([8, 8]);
      ctx.strokeRect((W - zw * 0.7) / 2, mh + zh * 0.1, zw * 0.7, zh * 0.8);
      ctx.setLineDash([]);
      ctx.fillStyle = '#a4968d';
      ctx.font = "22px 'DM Sans', Arial, sans-serif";
      ctx.textAlign = 'center';
      ctx.fillText(TXT.photoIci, W / 2, mh + zh / 2);
    }

    /* textes */
    var y0 = H - mb - h;
    el.forEach(function (e) {
      if (e.filet) {
        ctx.fillStyle = '#60524a';
        ctx.fillRect(W / 2 - 0.028 * W, y0 + e.y - 1, 0.056 * W, 1.5);
        return;
      }
      ctx.font = e.font;
      ctx.fillStyle = e.col;
      ecrire(e.txt, W / 2, y0 + e.y, e.esp);
    });
    /* le filigrane My Coopy Design est une image posee par-dessus (comme les cartes) */
  }

  /* ------------------------------------------------------------------
     interactions
     ------------------------------------------------------------------ */
  function statut(t, erreur) {
    var s = $('pe-status');
    s.textContent = t || '';
    s.style.color = erreur ? '#b3261e' : '#6b5d55';
  }

  $('pe-photo').addEventListener('change', function (e) {
    var f = e.target.files && e.target.files[0];
    if (!f) return;
    if (!/^image\//.test(f.type) && !/\.(heic|heif)$/i.test(f.name)) {
      statut(TXT.formatPhoto, true);
      return;
    }
    statut(TXT.preparation);
    var url = URL.createObjectURL(f);
    var img = new Image();
    img.onload = function () {
      if (Math.min(img.naturalWidth, img.naturalHeight) < 400) {
        statut(TXT.tropPetite, true);
        return;
      }
      photoOriginale = img;
      $('pe-thumb').src = url;
      $('pe-thumb-wrap').hidden = false;
      $('pe-photo-label').textContent = TXT.changer;
      if (exemple) { statut(''); return; }
      setTimeout(function () {
        portraitStylise = styliser(img);
        dessiner();
        statut('');
      }, 20);
    };
    img.onerror = function () {
      statut(TXT.illisible, true);
    };
    img.src = url;
  });

  ['pe-name', 'pe-dates', 'pe-phrase'].forEach(function (id) {
    $(id).addEventListener('input', dessiner);
  });
  $('pe-phrase').addEventListener('input', function () {
    $('pe-count').textContent = this.value.length + ' / 90';
  });

  /* photo reduite a 2400 px avant envoi : 1 a 2 Mo au lieu de 5 a 12 Mo */
  function photoPourEnvoi() {
    return new Promise(function (ok, ko) {
      var img = photoOriginale, max = 2400;
      var k = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
      var c = document.createElement('canvas');
      c.width = Math.round(img.naturalWidth * k);
      c.height = Math.round(img.naturalHeight * k);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      c.toBlob(function (b) { b ? ok(b) : ko(new Error('photo')); }, 'image/jpeg', 0.9);
    });
  }

  $('pe-add').addEventListener('click', function () {
    var bouton = this;
    if (!photoOriginale) { statut(TXT.sansPhoto, true); return; }
    if (!$('pe-name').value.trim()) { statut(TXT.sansNom, true); return; }
    if (!SERVEUR) { statut(TXT.indispo, true); return; }

    bouton.disabled = true;
    statut(TXT.envoi);

    photoPourEnvoi()
      .then(function (blob) {
        var fd = new FormData();
        fd.append('photo', blob, 'photo.jpg');
        fd.append('lang', LANG);
        return fetch(SERVEUR + '/upload-photo', { method: 'POST', body: fd });
      })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok || !j.photo) {
            var e = new Error(j.error || 'envoi');
            e.pourCliente = !!j.error;
            throw e;
          }
          return j.photo;
        });
      })
      .then(function (photo) {
        statut(TXT.panier);
        var nom = $('pe-name').value.trim();
        var dates = $('pe-dates').value.trim();
        var phrase = $('pe-phrase').value.trim();
        /* libelles visibles dans la langue de la cliente ; les proprietes
           commencant par _ sont celles que lit le serveur (independantes de la langue) */
        var props = {};
        props[TXT.pNom] = nom;
        if (dates) props[TXT.pDates] = dates;
        if (phrase) props[TXT.pPhrase] = phrase;
        props[TXT.pStyle] = TXT[STYLE];
        props._poster_nom = nom;
        props._poster_dates = dates;
        props._poster_phrase = phrase;
        props._poster_style = STYLE;
        props._poster_photo = photo;
        props._poster_lang = LANG;
        return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: VARIANTE, quantity: 1, properties: props }] })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('panier');
        window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart';
      })
      .catch(function (err) {
        console.error('[poster-editor]', err);
        bouton.disabled = false;
        statut(err && err.pourCliente ? err.message : TXT.erreur, true);
      });
  });

  function demarrer() { dessiner(); }
  if (document.fonts && document.fonts.load) {
    Promise.all([
      document.fonts.load("40px 'Playfair Display'"),
      document.fonts.load("italic 40px 'Playfair Display'"),
      document.fonts.load("40px 'Great Vibes'"),
      document.fonts.load("20px 'DM Sans'")
    ]).then(demarrer, demarrer);
  } else {
    demarrer();
  }
})();
